module.exports = __webpack_public_path__ + "img/周边服务.35334472.png";